import { ImageData } from "./imageState";
import { TypeCastingValidator } from "../../../utils/safe-type-casting";

export const imageValidator: TypeCastingValidator<ImageData> = {
  kind: 'object',
  fieldsValidator: {
    Url: { kind: 'string' },
    Title: { kind: 'string' },
  },
}